import { render } from "./CustomersFromChannels.vue?vue&type=template&id=b94beed4&scoped=true&ts=true"
import script from "./CustomersFromChannels.vue?vue&type=script&lang=ts"
export * from "./CustomersFromChannels.vue?vue&type=script&lang=ts"

import "./CustomersFromChannels.vue?vue&type=style&index=0&id=b94beed4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b94beed4"]])

export default __exports__